var React = require('react');

function Sales (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-ios-call","data-name":"Icon ionic-ios-call","d":"M23.912,20.162A16.8,16.8,0,0,0,20.4,17.814c-1.052-.505-1.437-.495-2.182.042-.62.448-1.02.864-1.734.708A10.343,10.343,0,0,1,13,15.986,10.268,10.268,0,0,1,10.428,12.5c-.151-.718.266-1.114.708-1.734.536-.745.552-1.13.042-2.182A16.467,16.467,0,0,0,8.829,5.079c-.765-.765-.937-.6-1.359-.448a7.733,7.733,0,0,0-1.244.661A3.754,3.754,0,0,0,4.732,6.87c-.3.64-.64,1.833,1.109,4.946a27.6,27.6,0,0,0,4.852,6.472h0l.005.005.005.005h0a27.707,27.707,0,0,0,6.472,4.852c3.113,1.749,4.306,1.406,4.946,1.109A3.69,3.69,0,0,0,23.7,22.765a7.733,7.733,0,0,0,.661-1.244C24.511,21.1,24.683,20.927,23.912,20.162Z","transform":"translate(-4.49 -4.502)","fill":"#e62a2c"}));
}

Sales.defaultProps = {"width":"20","height":"19.998","viewBox":"0 0 20 19.998"};

module.exports = Sales;

Sales.default = Sales;
